import { useState } from "react";
import { FiFolderPlus, FiPieChart } from "react-icons/fi";
import AppLayout from "../components/common/AppLayout";
import ConfirmModal from "../components/common/ConfirmModal";
import PresupuestoForm from "../components/presupuestos/PresupuestoForm";
import PresupuestoTable from "../components/presupuestos/PresupuestoTable";
import usePresupuestos from "../hooks/usePresupuestos";

export default function PresupuestosPage() {
    const { presupuestos, loading, guardar, eliminar } = usePresupuestos();
    const [open, setOpen] = useState(false);
    const [editing, setEditing] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [presupuestoAEliminar, setPresupuestoAEliminar] = useState(null);

    return (
        <AppLayout
            title={
                <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                    <FiPieChart size={30} />
                    Presupuestos
                </span>
            }
        >
            <div className="toolbar-row">
                <button
                    className="btn-primary"
                    type="button"
                    onClick={() => {
                        setEditing(null);
                        setOpen(true);
                    }}
                >
                    <FiFolderPlus size={18} />
                    Nuevo presupuesto
                </button>
            </div>

            {loading ? (
                <p>Cargando...</p>
            ) : (
                <PresupuestoTable
                    data={presupuestos}
                    onEdit={(row) => {
                        setEditing(row);
                        setOpen(true);
                    }}
                    onDelete={(row) => {
                        setPresupuestoAEliminar(row);
                        setConfirmOpen(true);
                    }}
                />
            )}

            {open && (
                <PresupuestoForm
                    initialData={editing}
                    onClose={() => setOpen(false)}
                    onSave={async (payload) => {
                        await guardar(payload, editing?.idPresupuesto);
                        setOpen(false);
                    }}
                />
            )}

            <ConfirmModal
                open={confirmOpen}
                title="Eliminar presupuesto"
                message={`¿Seguro que deseas eliminar el presupuesto de "${presupuestoAEliminar?.categoriaNombre || ""}" del mes "${presupuestoAEliminar?.mes || ""}"? Esta acción no se podrá deshacer.`}
                confirmText="Sí, eliminar"
                cancelText="Cancelar"
                variant="danger"
                onClose={() => {
                    setConfirmOpen(false);
                    setPresupuestoAEliminar(null);
                }}
                onConfirm={async () => {
                    await eliminar(presupuestoAEliminar.idPresupuesto);
                    setConfirmOpen(false);
                    setPresupuestoAEliminar(null);
                }}
            />
        </AppLayout>
    );
}